module.exports = __webpack_public_path__ + "static/media/atletico.4fa0acb0.png";